import React, { Children } from 'react';
import { SIDE_SHEET_HEADER_CLASS_PREFIX } from '../SideSheetHeader';
import { getElementName } from '../../../utils';
import { SIDE_SHEET_CLASS_PREFIX } from '../constants';
import { SIDE_SHEET_BODY_CLASS_PREFIX } from '../SideSheetBody';
import { SIDE_SHEET_FOOTER_CLASS_PREFIX } from '../SideSheetFooter';
export var extendChildrenWithProps = function extendChildrenWithProps(children, additionalProps) {
  if (!children) {
    return children;
  }

  var classOverride = additionalProps.classOverride,
      isFixed = additionalProps.isFixed,
      theme = additionalProps.theme;
  var className;
  return Children.map(children, function (child) {
    var childName = getElementName(child);

    if (childName && ![SIDE_SHEET_HEADER_CLASS_PREFIX, SIDE_SHEET_BODY_CLASS_PREFIX, SIDE_SHEET_FOOTER_CLASS_PREFIX].includes(childName)) {
      console.warn("Only ".concat(SIDE_SHEET_HEADER_CLASS_PREFIX, ", ").concat(SIDE_SHEET_HEADER_CLASS_PREFIX, " or ").concat(SIDE_SHEET_FOOTER_CLASS_PREFIX, " components can be used as children of ").concat(SIDE_SHEET_CLASS_PREFIX));
    }

    if (classOverride) {
      switch (childName) {
        case SIDE_SHEET_HEADER_CLASS_PREFIX:
          className = classOverride.Header;
          break;

        case SIDE_SHEET_BODY_CLASS_PREFIX:
          className = classOverride.Body;
          break;

        case SIDE_SHEET_FOOTER_CLASS_PREFIX:
          className = classOverride.Footer;
          break;

        default:
          className = '';
      }
    }

    return React.cloneElement(child, {
      isFixed: isFixed,
      theme: theme,
      className: className
    });
  });
};